import { ActionIcon, Tooltip } from '@mantine/core'
import IconCopy from 'src/icons/IconCopy'
import { toast } from 'src/components/Overlays/Toast/Toast'

type Props = {
  packageName?: string
  packageOrderId: string
}

const PackageNameCell = ({ packageName = '', packageOrderId }: Props) => {
  return (
    <div className="flex items-center gap-2">
      <span>{packageName}</span>
      <Tooltip label="Copy package order ID">
        <ActionIcon
          size={14}
          variant="subtle"
          onClick={(e) => {
            e.stopPropagation()
            toast('Copied package order ID to clipboard', 'success')
            navigator.clipboard.writeText(packageOrderId)
          }}
        >
          <IconCopy className="fill-none stroke-doubleNickel-gray-500" />
        </ActionIcon>
      </Tooltip>
    </div>
  )
}

export default PackageNameCell
